import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type DoorIconProps = {
  size?: number
  color?: string
  className?: string
}

export const DoorIcon = ({
  size = 17,
  color = tokenVar('colors.icon.secondary'),
  className,
}: DoorIconProps) => (
  <svg
    aria-label='Door'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 13 17'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.5 1L11.5 3.5V14L4.5 16V1Z'
      stroke={color}
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M4.5 3.5H1V14H4.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <circle cx='7.5' cy='9' fill={color} r='1' />
  </svg>
)
